import { createCrumb } from './createCrumb';

import type { Crumb } from 'layout/MainLayout/components/Header/hooks/useCrumbs/types';

export const handleFunctionCrumb = (
  title: string | null,
  currentHandle: Function,
  pathname: string,
  acc: Crumb[],
  dynamicCrumb: any,
): Crumb[] => [
  ...acc,
  createCrumb(
    currentHandle(title),
    pathname,
    dynamicCrumb[pathname]?.isLoading || false,
  ),
];
